import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Text } from '@pinpoint/design-kit';

import BaseDialog from './base';

function DeleteFrameworkDialog({ framework, isOpen, actions }) {
  return (
    <BaseDialog
      isOpen={isOpen}
      actions={actions}
      title={{
        text: 'Delete Framework',
        backgroundColor: 'marigold',
        color: 'white',
        textSize: 'title',
        icon: <Icon name="AlertSolid" color="white" viewBox="0 0 24 24" size="3.125rem" m={{ r: '1rem' }} />,
      }}
      items={{
        content: [
          <Text key="framework-delete-question" textSize="paragraph" textWeight="500" textColor="shade66">
            Are you sure you want to delete framework: {framework?.name}?
          </Text>,
        ],
        buttons: [
          {
            text: 'YES',
            textSize: 'body',
            close: true,
          },
        ],
      }}
    />
  );
}

DeleteFrameworkDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    cancel: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    close: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    handlers: PropTypes.arrayOf(
      PropTypes.shape({
        before: PropTypes.func,
        on: PropTypes.func.isRequired,
        after: PropTypes.func,
      })
    ),
  }).isRequired,
  framework: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
};

export default DeleteFrameworkDialog;
